import { reactive } from 'vue';

const DISMISSED_KEY = 'machineTranslationNoticeDismissed';

function wasDismissed() {
    if (typeof window === 'undefined') return false;
    try {
        return window.sessionStorage.getItem(DISMISSED_KEY) === 'true';
    } catch {
        return false;
    }
}

export const machineTranslationNoticeState = reactive({
    detected: false,
    dismissed: wasDismissed(),
});

export function markMachineTranslationDetected() {
    machineTranslationNoticeState.detected = true;
}

export function clearMachineTranslationDetected() {
    machineTranslationNoticeState.detected = false;
}

export function dismissMachineTranslationNotice() {
    machineTranslationNoticeState.dismissed = true;
    try {
        window.sessionStorage.setItem(DISMISSED_KEY, 'true');
    } catch {
        // The notice can still be dismissed for the current in-memory session.
    }
}
